
export default {
  props: {
    author: {
      type: Object,
      required: true,
    },
  },
};
